import { createContext, PropsWithChildren, useContext } from "react";
import { HotelSearchResponseItem } from "../../mobile/components/HotelSearchForm/Search/types";
import { SelectedAutoCompleteItem } from "../../mobile/components/HotelSearchForm/types";

export type HotelAutocompleteProps = {
  searchValue: string;
  handleSearchValueChange: (value: string) => void;
  results: HotelSearchResponseItem[];
  isAutoCompleteLoading: boolean;
  isAutocompleteError: boolean;
  handleSelectSearchItem: (item: SelectedAutoCompleteItem) => void;
  isAutocompleteNoResults: boolean;
};

const HotelAutocompleteContext = createContext<HotelAutocompleteProps>({
  searchValue: "",
  handleSearchValueChange: () => {},
  results: [],
  isAutoCompleteLoading: false,
  isAutocompleteError: false,
  handleSelectSearchItem: () => {},
  isAutocompleteNoResults: false,
});

export default function HotelAutocompleteProvider({
  children,
  ...props
}: PropsWithChildren<HotelAutocompleteProps>) {
  return (
    <HotelAutocompleteContext.Provider value={props}>
      {children}
    </HotelAutocompleteContext.Provider>
  );
}

export function useHotelAutocomplete() {
  const context = useContext(HotelAutocompleteContext);

  if (context === undefined) {
    throw new Error("`HotelAutocompleteContext` could not find any provider");
  }

  return context;
}
